import routerOptions0 from "/opt/build/repo/nuxt/node_modules/.pnpm/nuxt@3.19.1_@netlify+blobs@8.1.2_@parcel+watcher@2.5.1_@types+node@24.3.1_@vue+compiler_9ca5a9b21338589236999b36205589c3/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}